/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme, Typography } from '@material-ui/core';
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import CookieConsent from 'react-cookie-consent';
import ReactGA from 'react-ga';
import { hotjar } from 'react-hotjar';
import softWarTheme from './components/Theme/SoftWarTheme';
import About from './sections/About';
import Manual from './sections/Manual/Manual';
import Order from './sections/Order/Order';
import Feedback from './sections/Feedback/Feedback';
import Footer from './sections/Footer/Footer';
import Navigation from './components/Navigation';
import Home from './sections/Home/Home';
import Creators from './sections/Creators/Creators';
import Premiere from './sections/Premiere';
// import Credits from './sections/Credits/Credits';

const hjid = 1198803;
const hjsv = 6;

hotjar.initialize(hjid, hjsv);

ReactGA.initialize('UA-134387591-1');
ReactGA.pageview(window.location.pathname + window.location.search);

configureAnchors({ offset: -0, scrollDuration: 600 });

const swTheme = createMuiTheme(softWarTheme);

const theme = {
  ...swTheme
};

class App extends Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {/* <Header /> */}
        {/* <Triangles /> */}
        <Home />
        <ScrollableAnchor id="about">
          <About />
        </ScrollableAnchor>

        <ScrollableAnchor id="creators">
          <Creators />
        </ScrollableAnchor>

        <ScrollableAnchor id="manual">
          <Manual />
        </ScrollableAnchor>

        <ScrollableAnchor id="download">
          <Order />
        </ScrollableAnchor>

        <ScrollableAnchor id="feedback">
          <Feedback />
        </ScrollableAnchor>
        {/* <Credits /> */}
        <Footer />
        <CookieConsent
          location="top"
          buttonText="Om nom nom! (YES!)"
          cookieName="softwarcookie"
          style={{ background: '#fff', borderBottom: '1px solid #3d3d3d' }}
          buttonStyle={{
            background: '#00a8c2',
            color: '#fff',
            fontSize: '13px'
          }}
          expires={150}
        >
          <Typography variant="body1" align="center" style={{ color: '#000' }}>
            This website uses cookies for your pleasure and entertainment{' '}
            <img src="/images/assets/asset-45.png" height="20" alt="cookie" />
            <a
              href="https://drive.google.com/open?id=1dt3C9vDWu_x0pTsEMbn1iCPYm--Z9E1jDSVkn56XRlI"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'rgb(0, 168, 194)', textDecoration: 'none' }}
            >
              {' '}
              Cookie Policy
            </a>
          </Typography>
        </CookieConsent>
        <Premiere />
        <Navigation />
      </MuiThemeProvider>
    );
  }
}

export default App;
